<template>
    <div>
        <ForwardingAddressNotification />

        <TenancyExpiresNotification />

        <TenancyWorkflows v-if="$meta.features.tenants.workflows" />

        <div class="columns is-variable is-6">
            <div
                v-if="$meta.features.tenants.arrears"
                class="column is-12-tablet is-4-desktop"
            >
                <h4 class="title is-4">
                    Arrears
                </h4>

                <h6 class="subtitle is-6">
                    Being in arrears means you have an outstanding rent payment.
                </h6>

                <TenancyArrears />
            </div>

            <div
                v-if="$meta.features.tenants.charges"
                class="column is-12-tablet is-4-desktop"
            >
                <h4 class="title is-4">
                    Charges
                </h4>

                <h6 class="subtitle is-6">
                    Before moving in you'll likely need to pay some initial charges.
                </h6>

                <TenancyInitialCharges />
            </div>

            <div class="column is-12-tablet is-4-desktop">
                <h4 class="title is-4">
                    Appointments
                </h4>

                <h6 class="subtitle is-6">
                    Upcoming calendar appointments, with the ability to leave feedback on past viewing appointments.
                </h6>

                <TenancyAppointments />
            </div>
        </div>
    </div>
</template>

<script>
import TenancyAppointments from '../components/TenancyAppointments.vue';
import TenancyArrears from '../components/TenancyArrears.vue';
import TenancyInitialCharges from '../components/TenancyInitialCharges.vue';
import ForwardingAddressNotification from '../components/ForwardingAddressNotification.vue';
import TenancyExpiresNotification from '../components/TenancyExpiresNotification.vue';
import TenancyWorkflows from '../components/TenancyWorkflows.vue';
import { mapGetters, mapState } from 'vuex';

export default {
    components: {
        TenancyAppointments,
        TenancyArrears,
        TenancyInitialCharges,
        ForwardingAddressNotification,
        TenancyExpiresNotification,
        TenancyWorkflows,
    },

    computed: {
        ...mapState('tenancyProperty', [
            'tenancy',
        ]),

        ...mapGetters('tenancyProperty', [
            'isExpiring',
            'isRenewable',
        ]),
    },
};
</script>
